import { render, staticRenderFns } from "./TilesIconsSection.vue?vue&type=template&id=1f5bc1b7&scoped=true"
import script from "./TilesIconsSection.vue?vue&type=script&lang=js"
export * from "./TilesIconsSection.vue?vue&type=script&lang=js"
import style0 from "./TilesIconsSection.vue?vue&type=style&index=0&id=1f5bc1b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5bc1b7",
  null
  
)

export default component.exports